/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerSourceAllowNamesResponse } from './FindAllScreenerSourceAllowNamesResponse';
import {
    FindAllScreenerSourceAllowNamesResponseFromJSON,
    FindAllScreenerSourceAllowNamesResponseFromJSONTyped,
    FindAllScreenerSourceAllowNamesResponseToJSON,
} from './FindAllScreenerSourceAllowNamesResponse';

/**
 * 
 * @export
 * @interface FindAllSourceAllowNames200Response
 */
export interface FindAllSourceAllowNames200Response {
    /**
     * 
     * @type {FindAllScreenerSourceAllowNamesResponse}
     * @memberof FindAllSourceAllowNames200Response
     */
    data?: FindAllScreenerSourceAllowNamesResponse;
}

/**
 * Check if a given object implements the FindAllSourceAllowNames200Response interface.
 */
export function instanceOfFindAllSourceAllowNames200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllSourceAllowNames200ResponseFromJSON(json: any): FindAllSourceAllowNames200Response {
    return FindAllSourceAllowNames200ResponseFromJSONTyped(json, false);
}

export function FindAllSourceAllowNames200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllSourceAllowNames200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllScreenerSourceAllowNamesResponseFromJSON(json['data']),
    };
}

export function FindAllSourceAllowNames200ResponseToJSON(value?: FindAllSourceAllowNames200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllScreenerSourceAllowNamesResponseToJSON(value.data),
    };
}

